import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { Employee, TopicListItem } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';

export const CUSTOMER_TOPICS_REQUEST = 'CUSTOMER_TOPICS_REQUEST';
export const CUSTOMER_TOPICS_RECEIVED = 'CUSTOMER_TOPICS_RECEIVED';
export const CUSTOMER_TOPICS_CHANGE_EMPLOYEE_TOPICS = 'CUSTOMER_TOPICS_CHANGE_EMPLOYEE_TOPICS';

const receiveCustomerEmployeeTopics = (employees: Employee[]) => {
    return {
        type: CUSTOMER_TOPICS_RECEIVED,
        employees,
    };
};

export const fetchCustomerTopics = (customerId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CUSTOMER_TOPICS_REQUEST, customerId });
        const response = await api.contactsAndOrganizations.Customer.CustomerDetail.Topics.getEmployeeTopics(
            customerId
        );
        if (response.success) {
            dispatch(receiveCustomerEmployeeTopics(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const setEmployeeTopics = (customerId: number, employeeId: number, topics: TopicListItem[]) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CUSTOMER_TOPICS_CHANGE_EMPLOYEE_TOPICS, employeeId, topics });

        const response = await api.contactsAndOrganizations.Customer.CustomerDetail.Topics.updateEmployeeTopics(
            customerId,
            employeeId,
            topics.map(topic => topic.id)
        );

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.customerChangedEmployeeTopics')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
